import { z } from "zod";
export const DTOKnowledgeItemSearchIndexResponse = z.object({
    indexedItems: z.number(),
    totalItems: z.number(),
    skippedItems: z.number(),
    errors: z.number(),
});
export const DTOKnowledgeItemSearchKind = z.enum(["file", "skill"]);
export const DTOKnowledgeItemSearchQuery = z.object({
    query: z.string().min(1).max(1000),
    mode: z.enum(["full-text", "vector", "hybrid"]).optional().default("hybrid"),
    limit: z.number().int().min(1).max(50).optional().default(10),
    kinds: z.array(DTOKnowledgeItemSearchKind).optional(),
});
export const DTOKnowledgeItemSearchResult = z.object({
    knowledgeItemId: z.string(),
    kind: DTOKnowledgeItemSearchKind,
    path: z.string(),
    excerpt: z.string(),
    vectorScore: z.number().nullable(),
    fullTextScore: z.number().nullable(),
    reciprocalRankFusionScore: z.number(),
});
export const DTOKnowledgeItemSearchResponse = z.object({
    results: z.array(DTOKnowledgeItemSearchResult),
});
